module.exports = __webpack_public_path__ + "img/optimization.c86d21fa.png";